module.exports = __webpack_public_path__ + "img/hlpartn_logo.aaf0a786.png";